<!-- eslint-disable vue/no-v-for-template-key -->
<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte Turnos</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input
                  id="fechainicio"
                  placeholder="Fecha inicio"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="150px">
                <input
                  id="fechafin"
                  placeholder="Fecha final"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  v-on:click="getReporteTurnos"
                >
                  Actualizar
                </button>
              </td>
              <td>
                <button
                  class="btn btn-success"
                  type="submit"
                  v-on:click="sendToExcel"
                >
                  Exportar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table width="100%">
          <tbody>
            <tr>
              <td width="50%" style="vertical-align: top">
                <table width="100%" class="table table-sm font-oswald font-14">
                  <tbody>
                    <tr>
                      <th class="bg-kubber" width="20px"></th>
                      <th class="bg-kubber" width="20px">TURNO</th>
                      <th class="bg-kubber">PROMOTOR</th>
                      <th class="bg-kubber">1era VENTA</th>
                      <th class="bg-kubber">Ult VENTA</th>
                    </tr>
                    <tr v-for="item in reporte" :key="item">
                      <td>
                        <label :for="item.turno">
                          <input
                            :id="item.turno"
                            type="checkbox"
                            v-model="item.select"
                            v-on:change="recalculeTotal"
                          />
                        </label>
                      </td>
                      <td>
                        <label :for="item.turno">{{ item.turno }}</label>
                      </td>
                      <td>
                        <label :for="item.turno">{{ item.responsable }}</label>
                      </td>
                      <td>
                        <label :for="item.turno">{{
                          this.GLOBAL.FORMATO_TEXTO_FULL_FECHA(
                            item.jornada.fecha_inicio
                          )
                        }}</label>
                      </td>
                      <td>
                        <label :for="item.turno">{{
                          this.GLOBAL.FORMATO_TEXTO_FULL_FECHA(
                            item.jornada.fecha_finale
                          )
                        }}</label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td style="vertical-align: top">
                <div id="reporte">
                  <table
                    width="100%"
                    class="table table-sm font-oswald font-14"
                  >
                    <tbody>
                      <tr>
                        <td colspan="3" class="font-oswald font-14">REPORTE</td>
                      </tr>
                      <template v-for="item in tablaRegistros" :key="item">
                        <tr>
                          <th colspan="3" class="bg-kubber font-oswald font-14">
                            {{ item.producto }}
                          </th>
                        </tr>
                        <tr>
                          <td></td>
                          <td class="text-right" width="20%">CANT</td>
                          <td class="text-right" width="20%">TOTAL</td>
                        </tr>
                        <tr v-for="pers in item.personas" :key="pers">
                          <td>{{ pers.nombre }}</td>
                          <td class="text-right">
                            {{ this.GLOBAL.FORMATO_NUMBER(pers.galonaje) }}
                          </td>
                          <td class="text-right">
                            {{ this.GLOBAL.FORMATO_MONEY_BASIC(pers.venta) }}
                          </td>
                        </tr>

                        <tr>
                          <td></td>
                          <td class="text-right">
                            {{ GLOBAL.FORMATO_NUMBER(item.galonaje) }}
                          </td>
                          <td class="text-right">
                            {{ GLOBAL.FORMATO_MONEY_BASIC(item.venta) }}
                          </td>
                        </tr>
                      </template>

                      <tr>
                        <td colspan="3">&nbsp;</td>
                      </tr>
                      <template v-if="sumCantidadCanastilla > 0">
                        <tr>
                          <th colspan="3" class="bg-kubber font-oswald font-14">
                            CANASTILLA
                          </th>
                        </tr>
                        <template
                          v-for="vendedor in tablaCanastilla"
                          :key="vendedor"
                        >
                          <tr>
                            <th colspan="3" class="bg-ligth-gray">
                              {{ vendedor.responsable }}
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            <th width="20%">CANTIDAD</th>
                            <th width="20%">TOTAL</th>
                          </tr>
                          <tr v-for="item in vendedor.canastilla" :key="item">
                            <td>{{ item.producto }}</td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_NUMBER_BASIC(item.cantidad) }}
                            </td>
                            <td class="text-right">
                              {{ GLOBAL.FORMATO_MONEY_BASIC(item.venta) }}
                            </td>
                          </tr>
                          <tr class="font-weight-bold">
                            <td class="text-right">TOTAL</td>
                            <td class="text-right">
                              {{
                                GLOBAL.FORMATO_NUMBER_BASIC(
                                  totalCantidad(vendedor.canastilla)
                                )
                              }}
                            </td>
                            <td class="text-right">
                              {{
                                GLOBAL.FORMATO_MONEY_BASIC(
                                  totalVenta(vendedor.canastilla)
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="3">&nbsp;</td>
                          </tr>
                        </template>
                      </template>

                      <tr>
                        <td colspan="3">&nbsp;</td>
                      </tr>
                      <template v-if="totalPorResponsable.length">
                        <tr>
                          <th colspan="3" class="bg-kubber font-oswald font-14">
                            GRAN TOTAL
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th class="text-right">CANTIDAD + GALONAJE</th>
                          <th class="text-right">TOTAL VENTAS</th>
                        </tr>
                        <tr
                          v-for="responsable in totalPorResponsable"
                          :key="responsable.nombre"
                        >
                          <td>{{ responsable.nombre }}</td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_NUMBER(
                                responsable.totalGlobalCantidad
                              )
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(
                                responsable.totalGlobalVenta
                              )
                            }}
                          </td>
                        </tr>
                        <tr class="font-weight-bold">
                          <td class="text-right">GRAN TOTAL</td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_NUMBER(granTotalCantidadGalonaje)
                            }}
                          </td>
                          <td class="text-right">
                            {{
                              GLOBAL.FORMATO_MONEY_BASIC(granTotalVentaFinal)
                            }}
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import { BIconTelephoneMinus } from "bootstrap-vue";

export default {
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      person: null,
      mostrarEDS: true,
      permiso_lista: false,
      loading: true,
      tipo: 2,
      reporte: [],
      fechaInicio: "",
      fechaFin: "",
      sumCantidadCanastilla: 0,
      tablaRegistros: [],
      tablaCanastilla: [],
    };
  },
  computed: {
    // Calcula el total por cada responsable de venta
    totalPorResponsable() {
      return this.tablaCanastilla.map((vendedor) => {
        // Suma `cantidad` en `canastilla`
        const totalCantidad = vendedor.canastilla
          ? vendedor.canastilla.reduce(
              (acc, item) => acc + (item.cantidad || 0),
              0
            )
          : 0;

        const totalVenta = vendedor.canastilla
          ? vendedor.canastilla.reduce(
              (acc, item) => acc + (item.venta || 0),
              0
            )
          : 0;

        // Suma `galonaje` en `tablaRegistros` para cada producto asociado al responsable
        const totalCombustibleCantidad = this.tablaRegistros.reduce(
          (acc, registro) => {
            const matchingPersona = registro.personas.find(
              (pers) => pers.nombre === vendedor.responsable
            );
            return acc + (matchingPersona ? matchingPersona.galonaje || 0 : 0);
          },
          0
        );

        const totalCombustibleVenta = this.tablaRegistros.reduce(
          (acc, registro) => {
            const matchingPersona = registro.personas.find(
              (pers) => pers.nombre === vendedor.responsable
            );
            return acc + (matchingPersona ? matchingPersona.venta || 0 : 0);
          },
          0
        );

        return {
          nombre: vendedor.responsable,
          totalGlobalCantidad: totalCantidad + totalCombustibleCantidad,
          totalGlobalVenta: totalVenta + totalCombustibleVenta,
          totalCantidad,
          totalVenta,
        };
      });
    },

    // Calcula el gran total de cantidad + galonaje y ventas
    granTotalCantidadGalonaje() {
      return this.totalPorResponsable.reduce(
        (acc, item) => acc + item.totalGlobalCantidad,
        0
      );
    },
    // Calcula el gran total de cantidad + galonaje y ventas
    granTotalVentaFinal() {
      return this.totalPorResponsable.reduce(
        (acc, item) => acc + item.totalGlobalVenta,
        0
      );
    },
    // Calcula el gran total de cantidad y venta en todos los registros
    granTotalCantidad() {
      return this.totalPorResponsable.reduce(
        (acc, item) => acc + item.totalCantidad,
        0
      );
    },
    granTotalVenta() {
      return this.totalPorResponsable.reduce(
        (acc, item) => acc + item.totalVenta,
        0
      );
    },
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new ReporteService();
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate())
    );
    $("#fechafin").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate())
    );

    this.loading = false;
    $("input[datatype='fecha']").datepicker();
  },
  methods: {
    recalculeTotal() {
      this.sumCantidadCanastilla = 0;
      this.tablaRegistros = [];
      this.tablaCanastilla = [];
      this.tablaRegistros.personas = [];

      for (const i in this.reporte) {
        var responsable = this.reporte[i].responsable;
        var select = this.reporte[i].select;
        for (const v in this.reporte[i].totales) {
          var producto = this.reporte[i].totales[v].producto;

          var existe = false;
          for (const prd in this.tablaRegistros) {
            if (this.tablaRegistros[prd].producto == producto) {
              existe = true;
              break;
            }
          }
          if (!existe) {
            var registros = [];
            registros.producto = producto;
            registros.personas = [];
            registros.galonaje = 0;
            registros.venta = 0;

            if (select) {
              registros.galonaje = this.reporte[i].totales[v].galonaje;
              registros.venta = this.reporte[i].totales[v].venta;

              var persona = [];
              persona.nombre = responsable;

              persona.galonaje = this.reporte[i].totales[v].galonaje;
              persona.venta = this.reporte[i].totales[v].venta;

              registros.personas.push(persona);
            }

            this.tablaRegistros.push(registros);
          } else {
            for (const prd in this.tablaRegistros) {
              if (this.tablaRegistros[prd].producto == producto && select) {
                this.tablaRegistros[prd].galonaje +=
                  this.reporte[i].totales[v].galonaje;
                this.tablaRegistros[prd].venta +=
                  this.reporte[i].totales[v].venta;
                break;
              }
            }

            for (const prd in this.tablaRegistros) {
              if (this.tablaRegistros[prd].producto == producto && select) {
                var persona = [];
                persona.nombre = responsable;
                persona.galonaje = this.reporte[i].totales[v].galonaje;
                persona.venta = this.reporte[i].totales[v].venta;

                this.tablaRegistros[prd].personas.push(persona);
              }
            }
          }
        }

        if (select) {
          var item = {};
          item.identificacion = this.reporte[i].identificacion;
          item.responsable = this.reporte[i].responsable;
          item.canastilla = this.reporte[i].canastilla;

          var sumCantidad = this.totalCantidad(this.reporte[i].canastilla);
          this.sumCantidadCanastilla += sumCantidad;

          this.tablaCanastilla.push(item);
        }
      }
    },

    recalculeCantidad(valores) {
      let sum = 0;
      for (const i in valores) {
        sum += valores[i].cantidad;
      }
      return sum;
    },

    refrescarFactura() {
      this.facturaKey += 1;
    },

    getReporteTurnos() {
      this.fechaInicio = $("#fechainicio").val();
      this.fechaFin = $("#fechafin").val();

      this.reporte = [];
      this.loading = true;
      this.reporteService
        .getTurnosPromotores(
          this.person,
          this.fechaInicio,
          this.fechaFin,
          this.tipo
        )
        .then((data) => {
          this.reporte = data;
          this.loading = false;
        });
    },
    totalCantidad(canastilla) {
      if (canastilla == null) {
        return 0;
      }
      return canastilla.reduce((acc, item) => acc + (item.cantidad || 0), 0);
    },
    totalVenta(canastilla) {
      if (canastilla == null) {
        return 0;
      }
      return canastilla.reduce((acc, item) => acc + (item.venta || 0), 0);
    },

    sendToExcel() {
      // Obtener el contenido HTML de la tabla
      const tableHTML = document.querySelector("#reporte").outerHTML;

      // Endpoint de la API
      const url = GLOBAL.API_SEND_HTML_EXCEL;

      // Definir el nombre del archivo
      const fileName = "reporte_turno.xlsx"; // Puedes generar dinámicamente el nombre aquí

      // Realizar la solicitud POST
      axios
        .post(url, tableHTML, {
          responseType: "blob", // Importante para manejar archivos binarios
          headers: {
            "Content-Type": "text/html", // Enviar como HTML
            "Access-Control-Allow-Origin": "*",
            Authorization: "Basic " + this.person.token, // Incluye tu token si es necesario
            Environment: this.person.empresas, // Otros encabezados necesarios
            "File-Name": fileName, // Encabezado personalizado con el nombre del archivo
          },
        })
        .then((response) => {
          // Crear un enlace para descargar el archivo
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName; // Usar el mismo nombre aquí
          link.click();
          window.URL.revokeObjectURL(link.href); // Limpiar la URL del objeto
        })
        .catch((error) => {
          console.error("Error al generar el archivo Excel:", error);
        });
    },
  },
};
</script>

<style scoped>
.bg-ligth-gray {
  background-color: #ccc;
}
</style>
